export default "__VITE_ASSET__BhfGoTBA__"